import {
  AppBar,
  Box,
  Button,
  Container,
  Grid,
  Hidden,
  Paper,
  Tab,
  Tabs,
  Toolbar,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { PropTypes } from "prop-types";
import React, { useState, useEffect, useContext } from "react";
import SwipeableViews from "react-swipeable-views";
import { LeaderDashboardService } from "../../services/leaderDashboard.Service";
import GroupComparePlayers from "./GroupComparePlayers";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../common/RouteConstants";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { AppDataContext } from "../../common/appContext";

const useStyles = makeStyles((theme) => ({
  bgBlue: {
    height: "131vh",
    background:
      "-webkit-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
  },
  title: {
    flexGrow: 1,
    fontSize: "1.1rem",
    fontWeight: "450",
    paddingRight: "20px",
  },
  appbarBackground: {
    backgroundColor: "#fff",
    color: "#1d428a",
  },
  backButton: {
    backgroundColor: "white",
    minWidth: "50px",
    "&:hover": {
      backgroundColor: "white",
    },
    textTransform: "none",
    border: "1px solid lightgrey",
    boxShadow: "1px 1px 3px 1px lightgrey",
  },
  actionButtons: {
    padding: "0px 12px 0px 10px",
    height: "40px",
  },
  appbar: {
    backgroundColor: "#f5f5f5",
    color: "#000000",
    "& .Mui-selected": {
      color: theme.palette.primary.main,
    },
  },

  headerText: {
    marginBottom: theme.spacing(0.5),
    color: "#1d428a",
  },
}));
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function ComparePlayers() {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState(0);
  const theme = useTheme();
  const navigate = useNavigate();
  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
    if (newValue === 1) {
      navigate(RouteConstants.PLAYER_LIST);
    }
  };

  const { selectedEventId } = useContext(AppDataContext);
  const [notes, setNotes] = useState([]);

  const handleChangeIndex = (index) => {
    setSelectedTab(index);
  };

  useEffect(() => {
    LeaderDashboardService.getLeaderBoardNotes().then((response) => {
      //setNotes(response.data);

      //Filter the notes based on event.
      const filteredData = response.data.filter(
        (notes) => notes.childID === parseInt(selectedEventId)
      );

      //Make all unique notes and set to respective state.
      setNotes([
        ...new Map(filteredData.map((m) => [m.childName, m])).values(),
      ]);
    });
  }, [selectedEventId]);

  return (
    <>
      <AppBar position="static" className={classes.appbarBackground}>
        <Toolbar>
          <Box display="flex">
            <Typography noWrap variant="h6" className={classes.title}>
              Combine Results
            </Typography>
            {notes &&
              notes.length > 0 &&
              notes.find(
                (x) =>
                  x.childName.replace(/\s/g, "").toLowerCase() ===
                  "Anthropometrics".toLowerCase()
              ).isActive && (
                <>
                  <InfoOutlinedIcon
                    style={{ color: "#1d428a", paddingRight: "5px" }}
                  />
                  <Typography
                    variant="subtitle1"
                    className={classes.headerText}
                  >
                    {
                      notes.find(
                        (x) =>
                          x.childName.replace(/\s/g, "").toLowerCase() ===
                          "Anthropometrics".toLowerCase()
                      ).description
                    }
                  </Typography>
                </>
              )}
          </Box>
        </Toolbar>
      </AppBar>
      <Container maxWidth={false}>
        <Grid container pt={2} pb={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container>
              <Grid item lg xs={12}>
                <Paper
                  elevation={8}
                  sx={{
                    borderRadius: "16px",
                  }}
                >
                  <Box
                    component="div"
                    display="flex"
                    flexGrow={1}
                    flexDirection="column"
                    className={classes.paperStyle}
                  >
                    <AppBar
                      position="static"
                      className={classes.appbar}
                      sx={{
                        borderTopLeftRadius: "15px !important",
                        borderTopRightRadius: "15px !important",
                      }}
                    >
                      <Hidden mdUp>
                        <Tabs
                          scrollButtons
                          allowScrollButtonsMobile
                          value={selectedTab}
                          onChange={handleChange}
                          indicatorColor="primary"
                          textColor="inherit"
                          variant="scrollable"
                          aria-label="full width tabs example"
                          // selectionFollowsFocus
                        >
                          <Tab
                            sx={{ textTransform: "none" }}
                            label="Group Combine Results"
                            {...a11yProps(0)}
                          />
                          {/* <Tab
                              sx={{ textTransform: "none" }}
                              label="Individual Combine Results"
                              {...a11yProps(1)}
                            /> */}
                        </Tabs>
                      </Hidden>
                      <Hidden mdDown>
                        <Tabs
                          scrollButtons
                          allowScrollButtonsMobile
                          value={selectedTab}
                          onChange={handleChange}
                          indicatorColor="primary"
                          textColor="inherit"
                          variant="standard"
                          aria-label="full width tabs example"
                        >
                          <Tab
                            sx={{ textTransform: "none" }}
                            label="Group Combine Results"
                            {...a11yProps(0)}
                          ></Tab>
                          {/* <Tab
                              sx={{ textTransform: "none" }}
                              label="Individual Combine Results"
                              {...a11yProps(1)}
                            /> */}
                        </Tabs>
                      </Hidden>
                    </AppBar>
                    <SwipeableViews
                      className={classes.swipeView}
                      axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                      index={selectedTab}
                      onChangeIndex={handleChangeIndex}
                    >
                      <TabPanel
                        value={selectedTab}
                        index={0}
                        dir={theme.direction}
                      >
                        <GroupComparePlayers />
                      </TabPanel>
                    </SwipeableViews>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
